import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import assets from 'modules/assets'
import { Link } from 'react-router'
import GoogleMapReact from 'google-map-react'
import * as actions from 'actions'

const MapMarker = ({ text }) => (
  <img src={assets('images/map_marker.png')} style={{height: '35px', width: 'auto', 'marginTop': '-35px', 'marginLeft': '-11px'}} />
)

class RowThreeText extends Component {
  constructor(props) {
    super(props)
    this.state = { ...props }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  facebookPixelTrack(button) {
    if (!button.fbPixelTrack)
      return
    fbq('trackCustom', button.eventName, {
      fromPage: '/kohai'
    })
  }
  navigateToLink(url) {
    window.open(url, '_blank')
  }
  scrollIntoViewIfNecessary() {
    if (this.state.isScrollIntoView) {
      this.props.dispatch(actions.token.toggleMinimizeAlert(true))
      setTimeout(() => {
        this.refs.section.scrollIntoView()
      }, 1)
    }
  }
  componentDidMount() {
    this.scrollIntoViewIfNecessary()
  }
  componentDidUpdate() {
    this.scrollIntoViewIfNecessary()
  }
  getParagraphStyles(content, el, i) {
    let addSpace = content[i + 1] && (content[i + 1].type === 'p' || content[i + 1].type[0] === 'h')
    let pStyle = addSpace ? {marginBottom: '15px'} : {}
    let styles = el.style ? el.style : ''
    if (typeof styles === 'string') styles = [styles]
    if (el.hasMarginTop) pStyle['marginTop'] = '15px'
    if (styles.indexOf('large') != -1) {
      pStyle['fontSize'] = '25px'
      pStyle['lineHeight'] = '1.4'
    }
    if (styles.indexOf('medium-large') != -1) {
      pStyle['fontSize'] = '22px'
      pStyle['lineHeight'] = '1.4'
    }
    if (styles.indexOf('small') != -1) {
      pStyle['fontSize'] = '12px'
      pStyle['lineHeight'] = '1.4'
      pStyle['marginBottom'] = addSpace ? '5px' : 0
    }

    if (styles.indexOf('half') != -1) {
      pStyle['maxWidth'] = '50%'
    }

    if (styles.indexOf('two-thirds') != -1) {
      pStyle['maxWidth'] = '66%'
    }

    if (styles.indexOf('bold') != -1) {
      pStyle['fontWeight'] = 'bold'
    }

    if (styles.indexOf('marginTop') != -1) {
      pStyle['marginTop'] = '35px'
    }

    if (el.noMarginBottom) pStyle['marginBottom'] = '0'

    return pStyle
  }
  parse(content) {
    if (typeof content === 'undefined') {
      return ''
    }

    // TODO: refactor/clean up
    return content && content.map((el, i) => {
      switch (el.type) {
        case 'map':
            return (
              <div style={{'height': '300px', 'marginTop': '25px', 'marginBottom': '40px', 'cursor':'pointer'}} onClick={this.navigateToLink.bind(this, el.link)}>
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: 'AIzaSyBYNx7F0Mr_7FOCduTTEp0bkM1z7wXj5H0',
                    language: 'en'
                  }}
                  defaultCenter={el.center}
                  defaultZoom={el.zoom}
                  draggable={false}
                  options={{
                    scrollwheel: false
                  }}
                  onClick={this.navigateToLink.bind(this, el.link)}
                >
                  <MapMarker lat={el.center.lat} lng={el.center.lng} onClick={this.navigateToLink.bind(this, el.link)}/>
                </GoogleMapReact>
              </div>
            )
        case 'p':
            let pStyle = this.getParagraphStyles(content, el, i)
            let pButton
            if (el.button) {
              if (el.button.outbound)
                pButton = <a href={el.button.linkURL} onClick={this.facebookPixelTrack.bind(this, el.button)} target="__blank"><button style={{marginTop: el.content.length == 0 ? 0 : '25px'}}>{el.button.content}</button></a>
              else
                pButton = <Link to={el.button.linkURL}><button style={{marginTop: el.content.length == 0 ? 0 : '25px'}}>{el.button.content}</button></Link>
            }
            if (typeof el.content === 'string') el.content = [el.content]
            let paragraphContent =
              el.content.map((ct, i) => {
                return <p key={i} style={pStyle}>{(
                  ct.split('\n').map(function(item) {
                    let textStyle = {}
                    if (item[0] == '+') {
                      textStyle['paddingLeft'] = '15px'
                      textStyle['textIndent'] = '-15px'
                    }
                    return (
                      <div style={textStyle}> {item} </div>
                    )
                  })
                )}
                {pButton}
                </p>
              })
            if (el.linkURL) {
              return <a href={el.linkURL} className='underline' target='__blank'>{paragraphContent}</a>
            } else {
              return (paragraphContent)
            }
            break
        case 'h2':
            return el.content.map((label, i) => { return <h2 key={i}>{label}</h2> })
        case 'h3':
            let isSectraLight = el.style == 'sectra-light'
            let noMarginBottom = el.noMarginBottom
            return (
              el.content.map((label, i) => {
                let className = (i > 0 || isSectraLight) ? 'sectra-light' : ''
                let style = (label === '' && window.innerWidth > 480) ? {minHeight: '28px'} : {}
                if (noMarginBottom) style.marginBottom = 0
                return <h3 key={i} className={className} style={style}>{label.split('\n').map((item) => {
                  return <div>{item}</div>
                })}</h3>
              })
            )
        case 'h5':
            let className = el.style ? el.style : '',
                mailTo = el.mailTo ? <span className="enveloppe">✉</span> : '',
                h5 = <h5 key={i} className={className}>{mailTo}{el.content}</h5>,
                custom = { marginTop: '0', marginBottom: '5px', display: 'inline-block' },
                style = (!el.style || el.style !== 'sectra-light') ? custom : {}
            if (el.mailTo) {
              // create a mailto link
              return <div><a className="link" key={i} style={style} href={el.linkURL} target="_top">{h5}</a></div>
            } else if (el.outbound) {
              // use <a> tag
              return <a className="link" key={i} style={style} href={el.linkURL} target="_blank">{h5}</a>
            } else {
              // use <Link> for smooth transition
              return el.linkURL ? <Link className="link" key={i} to={el.linkURL} style={style}>{h5}</Link> : <div key={i} style={style}>{h5}</div>
            }
        case 'ol':
            let button = '', button2 = '', definition
            if (el.button) {
              if (el.button.outbound)
                button = <a href={el.button.linkURL} onClick={this.facebookPixelTrack.bind(this, el.button)} target="__blank"><button style={{marginTop: '25px'}}>{el.button.content}</button></a>
              else
                button = <Link to={el.button.linkURL}><button style={{marginTop: '25px'}}>{el.button.content}</button></Link>
            }
            if (el.button2) {
              if (el.button2.outbound)
                button2 = <a href={el.button2.linkURL} target="__blank"><button style={{marginTop: '25px'}}>{el.button2.content}</button></a>
              else
                button2 = <Link to={el.button2.linkURL}><button style={{marginTop: '25px'}}>{el.button2.content}</button></Link>
            }
            if (el.definition)
              definition = <h3 className="sectra-light">{el.definition}</h3>
            else
              definition = ''

            const olStyle = (el.style && el.style.indexOf('no-min-height') != -1) ? {minHeight: '220px', marginBottom: '30px'} : {}
            const lineHeight = (el.style && el.style.indexOf('medium-large') != -1) ? '1.4' : 'inherit'
            const fontSize = (el.style && el.style.indexOf('medium-large') != -1) ? '22px' : 'inherit'
            const maxWidth = (el.style && el.style.indexOf('two-thirds') != -1) ? '75%' : '100%'
            const liFontFamily = `Eesti Text Light', sans-serif`

            return (
              <ol key={i} style={olStyle}>
                {definition}
                <li style={{lineHeight: lineHeight, fontSize: fontSize, fontFamily: liFontFamily}}><p style={{lineHeight: lineHeight, fontSize: fontSize, maxWidth: maxWidth}}>{el.content[0]}</p></li>
                <li style={{lineHeight: lineHeight, fontSize: fontSize, fontFamily: liFontFamily}}><p style={{lineHeight: lineHeight, fontSize: fontSize, maxWidth: maxWidth}}>{el.content[1]}</p></li>
                {button}
                {button2}
              </ol>
            )
        case 'square-image':
            return (
              <div className="row-three-square">
                <img src={assets(el.src)} />
              </div>
            )
      }
    })
  }
  render() {
    let data
    if (this.state && this.state.data) {
      data = this.state.data
    }

    let marginTopStyle = ''
    if (data && data.marginTopStyle)
      marginTopStyle = data.marginTopStyle
    let sectionTitle = data && data.sectionTitle ? <h3 style={{marginBottom: '25px'}}>{data.sectionTitle}</h3> : ''

    let content
    if (data && data.large) {
      content = (
        <li className="grid-large inner-left fade-in" style={{width: '82vmin'}}>
            { this.parse(data && data.content[1]) }
        </li>
      )
    } else {
      content = (
        <div>
          <li className="grid-small grid-middle fade-in">
            { this.parse(data && data.content[1]) }
          </li>
          <li className="grid-small fade-in">
            { this.parse(data && data.content[2]) }
          </li>
        </div>
      )
    }

    let sectionClassNames = 'main-grid center' + ' ' + marginTopStyle

    return (
      <div>
        <div ref="section" style={{width: '100%', height: '1px'}}>
        </div>
        <section className={sectionClassNames}>
          <ul className="grid group">
            {sectionTitle}

            <li className="grid-small fade-in">
              { this.parse(data && data.content[0]) }
            </li>

            {content}
          </ul>
        </section>
      </div>
    )
  }
}
RowThreeText.contextTypes = {
}
RowThreeText.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(RowThreeText)



// WEBPACK FOOTER //
// ./src/components/Utils/RowThreeText.js